import React from 'react';
import PropTypes from 'prop-types';
import ReadMore from 'ggApp/shared/screens/ProductDetailsPage/ReadMore';

import {
    BulletList,
    BulletPoints,
    DescriptionText,
    ShortDescription,
    DescriptionTitle,
    StyledTypography,
} from './styles';

const ProductDescription = ({ className, productText, shortDescription }) => {
    const { title, text } = productText || {};
    return (
        <ReadMore className={className}>
            {shortDescription && <ShortDescription>{shortDescription}</ShortDescription>}
            {title && <DescriptionTitle>{title}</DescriptionTitle>}
            {text && (
                <StyledTypography
                    overrides={{ ul: BulletList, li: BulletPoints, p: DescriptionText }}
                    html={text}
                />
            )}
        </ReadMore>
    );
};

ProductDescription.propTypes = {
    productText: PropTypes.shape({
        title: PropTypes.string,
        text: PropTypes.string,
    }),
    className: PropTypes.string,
};

ProductDescription.defaultProps = {
    className: '',
    productText: {},
};

export default ProductDescription;
